export default __webpack_public_path__ + "static/Mobile-Book Now_main image@2x-ff775766da9569cfd12b635d3581a26a.jpg";